import React, { useState, useRef} from 'react';
import { message, Upload, Input, Form, Modal} from 'antd';
import {Link} from 'react-router-dom';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import OTPInput from "react-otp-input";
function ProfileInfo() {
    const [uploadImage, setUploadImage] = useState();
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [OTP, setOTP] = useState("");
    const userLogin = JSON.parse(localStorage.getItem("userLogin"));
    
    const useFocus = () => {
        const htmlElRef = useRef(null)
        const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

        return [htmlElRef, setFocus]
    }
    const [inputRef, setInputFocus] = useFocus();
    
    const NoteList = [
        { content: <span>Thêm <Link onClick={setInputFocus}>số điện thoại</Link> để hoàn tất hồ sơ</span> },
        { content: <span>cập nhật <Link to="/profile/personal-document">giấy tờ cá nhân</Link> để hoàn tất hồ sơ</span> }];
    const [note, setNote] = useState(NoteList)
    
    
    const handleModal = (e)=>{
        
        setOpenModal(true)
    }

    const handleCancel =()=>{
        setOpenModal(false)
    }


    const closeNote = (content)=>{
        setNote(note.filter(item => item.content !== content))
    }
    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }
    
    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, imageUrl =>{
                setUploadImage(imageUrl);
                setLoading(false);
            }
                
            );
        }
    };
    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload <br /> Avatar</div>
        </div>
    );
    return (
        <div className="profileInfo">
            <div className="profileNote">
                <ul>
                    {note.map(item=>{
                        return(
                            <li><div><img className="img-fluid ic_add" src="/images/ic_add.png" alt="" />{item.content}</div><img onClick={() => closeNote(item.content)} className="img-fluid ic_close" src="images/ic_close.png" alt="" /></li>
                        )
                    })}
                    
                </ul>
            </div>
            <div className="avatarProfile">
                <div className="avatar">
                    <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatarImage"
                        showUploadList={false}
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        beforeUpload={beforeUpload}
                        onChange={handleChange}
                    >
                        {uploadImage ? <img src={uploadImage} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                </div>
                <div className="userName">{userLogin.username}</div>
            </div>
            <div className="profileContent">
                <Form >
                    <Form.Item className="formInput"
                        label="Họ và tên"
                        name="fullname"
                    >
                        <Input
                            type="text"
                        />
                    </Form.Item>
                    <Form.Item className="formInput"
                        label="Tên tài khoản"
                        name="usetname"
                    >
                        <Input
                            type="text"
                        />
                    </Form.Item>
                    <Form.Item className="formInput"
                        label="SỐ ĐIỆN THOẠI"
                        name="phone"
                    >
                        <Input
                            ref={inputRef}
                            type="text"
                            placeholder="Nhập số điện thoại"
                        />
                    </Form.Item>
                    <Form.Item className="formInput"
                        label="EMAIL"
                        name="email"
                    >
                        <Input
                            type="text"
                        />
                    </Form.Item>
                    <Form.Item className="formInput"
                        label="EMAIL HOẶC SỐ ĐIỆN THOẠI Nhận thông báo"
                        name="emailNoti"
                    >
                        <Input
                            type="text"
                            suffix={
                                <div className="editInput" onClick={handleModal}><img className="img-fluid" src="/images/ic_edit.png" alt="" /></div>
                            }
                        />
                        <Modal
                            title="Xác thực"
                            className="OTPModal modalStyle "
                            visible={openModal}
                            onCancel={handleCancel}
                            footer={null}
                        >
                            <div className>
                                <p>Mã xác thực được gửi tới JO qua email <br /> <span>abc@gmail.com</span></p>
                                <div className="OTPBox">
                                    <OTPInput
                                        value={OTP}
                                        onChange={setOTP}
                                        autoFocus
                                        OTPLength={4}
                                        otpType="number"
                                        disabled={false}
                                        secure
                                        className="OTPStyle"
                                    />
                                </div>
                            </div>
                        </Modal>
                    </Form.Item>
                    <Form.Item className="btnModal">
                        <button className="btnStyle" >
                            Cập nhật
                        </button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
export default ProfileInfo;